import { REGION } from "./actionTypes";
import { createActions } from "../../helpers/utils/createActions";

export const getListaRegion = createActions(REGION.GET_LIST);
export const getRegion = createActions(REGION.GET_ITEM);
export const saveRegion = createActions(REGION.SAVE_ITEM);

export const loadEmptyRegion = () => ({ type: REGION.LOAD_EMPTY, });
export const cleanMessageRegion = () => ({ type: REGION.CLEAN_MESSAGE, });
export const changePageSizeRegion = (payload) => ({ type: REGION.CHANGE_PAGE_SIZE_REGION, payload });